import { toast } from '@/common/util'
import baseApi from './base.api'

const api = {
  ...baseApi,
  resource: 'scormacompanhamento',

  async getProgressScorm(midiaId: string, query?: { inscricaoId?: string }) {
    try {
      return api.get(`midia/${midiaId}`, { inscricaoId: query?.inscricaoId })
    } catch (error) {
      toast.error({ message: 'Erro ao tentar buscar dados sobre o scorm!' })
      throw error
    }
  }
}

export default api